import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { selectRowItem } from '../../store/slice'

export const ShortContentCell = ({ id, isHovered, rowIndex }) => {
  const data = useSelector(selectRowItem(id))
  return (
    <Element
      elementName="td"
      colSpan="5"
      style={{
        color: '#3A414B',
        backgroundColor: isHovered
          ? '#EDF5FE'
          : rowIndex % 2 === 0
          ? '#F9F9F9'
          : '#FFFFFF',
      }}
    >
      <div>
        {data.shortContent}{' '}
        <a href={data.sourceUrl} style={{ color: '#2c73e8' }} target="__blank">
          <Translate value="newsAndSocial.LINK_ARTICLE" />
        </a>
      </div>
    </Element>
  )
}
